import React, { useEffect, useState } from "react";
// import { useTranslation } from "react-i18next";
import step1Icon from "../../../assets/images/tracking-icons/order-delivery.svg";
import step2Icon from "../../../assets/images/tracking-icons/air-freight.svg";
import step3Icon from "../../../assets/images/tracking-icons/order-arrived-at-destination2.svg";
import step4Icon from "../../../assets/images/tracking-icons/customs.svg";
import step5Icon from "../../../assets/images/tracking-icons/received-by-agent.svg";
import step6aIcon from "../../../assets/images/tracking-icons/delivery-truck.svg";
import step6bIcon from "../../../assets/images/tracking-icons/waiting-for-pickup.svg";
import step7Icon from "../../../assets/images/tracking-icons/check.svg";
import stepServiceCenterIcon from "../../../assets/images/tracking-icons/service-center.svg";
import stepReturnReceivedIcon from "../../../assets/images/tracking-icons/return-received-at-pdo.svg";
import { useTranslation } from "react-i18next";

const steps = { 
	PUD: [
		{
			icon: step1Icon,
			title: "orderReceived",
		},
		{
			icon: step2Icon,
			title: "orderDispatched",
		},
		{
			icon: step3Icon,
			title: "orderArrivedAtDestination",
		},
		{
			icon: step4Icon,
			title: "customsCleared",
		},
		{
			icon: step5Icon,
			title: "receivedByDeliveryAgent",
		},
		{
			icon: step6bIcon,
			title: "packageWaitingForPickUpByBuyer",
		},
		{
			icon: step7Icon,
			title: "delivered",
		},
	],
	HD: [
		{
			icon: step1Icon,
			title: "orderReceived",
		},
		{
			icon: step2Icon,
			title: "orderDispatched",
		},
		{
			icon: step3Icon,
			title: "orderArrivedAtDestination",
		},
		{
			icon: step4Icon,
			title: "customsCleared",
		},
		{
			icon: step5Icon,
			title: "receivedByDeliveryAgent",
		},
		{
			icon: step6aIcon,
			title: "outForDelivery",
		},
		{
			icon: step7Icon,
			title: "delivered",
		},
	],
	returnDelivery: [
		{
			icon: step1Icon,
			title: "returnDetailsReceived",
		},
		{
			icon: stepReturnReceivedIcon,
			title: "returnReceivedAtPUDO",
		},
		{
			icon: step5Icon,
			title: "returnGoingToSortingCenter",
		},
		{
			icon: stepServiceCenterIcon,
			title: "returnInSortingCenter",
		},
		{
			icon: step6aIcon,
			title: "returnOutForDeliveryToWarehouse",
		},
		{
			icon: step7Icon,
			title: "returned",
		},
	]
}

const TrackingStepsBar = ({ statusHistory, processSteps, deliveryMethod, isReturn }) => {
const { t } = useTranslation("tracking");
  let currentStep = -1;
  statusHistory && processSteps && statusHistory.forEach(item => {
    const statusStep = processSteps.find(step => {
      return step.statusCodes.indexOf(item.statusCode) != -1;
    })
    if (statusStep?.stepNumber && statusStep?.stepNumber > currentStep) {
      currentStep = statusStep?.stepNumber;
    }
	});
	if (!statusHistory || !statusHistory.length) {
		return null;
	}

	const getSteps = () => isReturn ? steps["returnDelivery"] : steps[deliveryMethod] || [];
	const isActiveStep = (i, currentStep) => {
		const loopStep = i + 1;
		return loopStep === currentStep;
	}
	return (
		<div className="steps-bar-wrap animated fadeIn">
			{getSteps().map((step, i) => (
				<div className={`step ${isActiveStep(i, currentStep) ? "current" : ""} step${i}` } key={`step${i}`}>
					<div className="icon">
						<img src={step.icon} alt={step.title} />
					</div>
					<div className="step-title">{t(step.title)}</div>
				</div>
			))}
		</div>
	);
};

export { TrackingStepsBar };
